/*
 * @Author: zhang lin
 * @Date: 2022-04-08 13:09:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-15 09:20:41
 * @Description: file content
 */
import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Radio, Select } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import { useIntl } from 'react-intl';
import messages from 'root/pages/InstallSupos/messages';
import styles from './index.less';

import { getHostDetailApi } from 'root/services/disk';
import { getLanguageApi } from 'root/services/manager';

import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { setIsMultiTenant, setDomain } from 'root/store/tenant/actions';

const { Option } = Select;

interface FCFormProps extends FormComponentProps {
  onSubmit: () => void;
  supOSConfigData: { [key: string]: any }; // 表单数据
  updateCpuAndMemoryCheckRes: (type: string, value: boolean) => void;
  failMes: string; // 测试ssh 失败
}
const Authorization = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { isMultiTenant, domain } = useSelector((state: reducerStates) => state.tenant);
  const { form, supOSConfigData, failMes } = props;
  const { supos = {} } = supOSConfigData;
  const { getFieldDecorator, getFieldValue } = form;
  const [hostList, setHostList] = useState<any>([]);
  const [languageList, setLanguageList] = useState<{ name: string; cnName: string }[]>([]);

  useImperativeHandle(ref, () => ({
    form,
  }));

  useEffect(() => {
    getHostList();
    initLanguage();
  }, []);

  // 获取所有的主机节点
  const getHostList = () => {
    getHostDetailApi({ ids: [], nameOrIp: '' }).then((res) => {
      const { data } = res;
      const { serverNodeBriefs } = data;
      if (serverNodeBriefs.length) setHostList(serverNodeBriefs);
    });
  };
  // 获取语言列表
  const initLanguage = async () => {
    await getLanguageApi().then((res: any) => {
      const { data } = res;
      setLanguageList(data);
    });
  };

  const repeatIpCheck = (rule: any, value: string, callbackFn: Function) => {
    const ip1 = form.getFieldValue('authorizedDogAddress1');
    const ip2 = form.getFieldValue('authorizedDogAddress2');
    const reg =
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(:([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5]))?$/;

    if (!value) {
      return callbackFn();
    }

    if (!reg.test(value)) {
      return callbackFn(intl.formatMessage(messages.serverError));
    }

    if (ip1 === ip2) {
      return callbackFn(intl.formatMessage(messages.ipRepeat));
    }

    callbackFn();
  };

  const changeIp = () => {
    form.setFieldsValue({ authorizedDogAddress1: undefined, authorizedDogAddress2: undefined });
  };

  // 切换租户模式选择
  const changeTenant = (ele: any) => {
    dispatch(setIsMultiTenant(ele.target.value));
  };

  // 设置泛域名
  const domainInput = (ele: any) => {
    dispatch(setDomain(ele.target.value));
  };

  // 授权信息内容
  const authorization = () => {
    const { licensingInstalled = true, authorizedDogAddress1, authorizedDogAddress2 } = supos;

    return (
      <>
        <h4 className={styles.title}>{intl.formatMessage(messages.authorization)}</h4>
        <Form.Item label={intl.formatMessage(messages.licensingInstalled)} colon={false}>
          {getFieldDecorator('licensingInstalled', {
            initialValue: licensingInstalled === undefined ? true : licensingInstalled,
          })(
            <Radio.Group onChange={changeIp}>
              <Radio value={true}>{intl.formatMessage(messages.installed)}</Radio>
              <Radio value={false}>{intl.formatMessage(messages.noInstall)}</Radio>
            </Radio.Group>,
          )}
        </Form.Item>

        <>
          <Form.Item label={`${intl.formatMessage(messages.authorizedDogAddress)}1`} colon={false}>
            {getFieldDecorator('authorizedDogAddress1', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.serverNull),
                },
                {
                  validator: repeatIpCheck,
                },
              ],
              initialValue: authorizedDogAddress1,
            })(
              form.getFieldValue('licensingInstalled') ? (
                <Input
                  autoComplete="off"
                  maxLength="64"
                  placeholder={intl.formatMessage(messages.authorizedAddressInput)}
                />
              ) : (
                <Select placeholder={intl.formatMessage(messages.authorizedAddressSelect)}>
                  {hostList.map((item: any) => {
                    return (
                      <Option value={item.ip} key={item.ip}>
                        {item.ip}
                      </Option>
                    );
                  })}
                </Select>
              ),
            )}
          </Form.Item>
          <Form.Item label={`${intl.formatMessage(messages.authorizedDogAddress)}2`} colon={false}>
            {getFieldDecorator('authorizedDogAddress2', {
              rules: [
                {
                  validator: repeatIpCheck,
                },
              ],
              initialValue: authorizedDogAddress2,
            })(
              form.getFieldValue('licensingInstalled') ? (
                <Input
                  autoComplete="off"
                  maxLength="64"
                  placeholder={intl.formatMessage(messages.authorizedAddressInput)}
                />
              ) : (
                <Select allowClear={true} placeholder={intl.formatMessage(messages.authorizedAddressSelect)}>
                  {hostList.map((item: any) => {
                    return (
                      <Option value={item.ip} key={item.ip}>
                        {item.ip}
                      </Option>
                    );
                  })}
                </Select>
              ),
            )}
          </Form.Item>
        </>
      </>
    );
  };

  // 设置租户内容
  const renderTenant = () => {
    return (
      <div>
        <h4 className={styles.title}>{intl.formatMessage(messages.tenantModeConfig)}</h4>
        <Form.Item label={intl.formatMessage(messages.mode)} colon={false}>
          {getFieldDecorator('isMultiTenant', { initialValue: isMultiTenant })(
            <Radio.Group onChange={changeTenant}>
              <Radio value={false}>{intl.formatMessage(messages.singleTenant)}</Radio>
              <Radio value={true}>{intl.formatMessage(messages.multitenancy)}</Radio>
            </Radio.Group>,
          )}
        </Form.Item>
        {getFieldValue('isMultiTenant') && (
          <Form.Item label={`${intl.formatMessage(messages.universalDomainName)}`} colon={false}>
            {getFieldDecorator('domain', {
              rules: [
                {
                  required: true,
                  message: intl.formatMessage(messages.nameNull),
                },
                {
                  pattern: new RegExp(
                    /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/,
                  ),
                  message: intl.formatMessage(messages.nameError),
                },
              ],
              initialValue: domain,
            })(
              <Input
                autoComplete="off"
                maxLength="64"
                placeholder={intl.formatMessage(messages.nameTip)}
                onInput={domainInput}
              />,
            )}
          </Form.Item>
        )}
      </div>
    );
  };

  // 语言信息
  const language = () => {
    let initialValue = '';
    if (languageList.length) {
      initialValue = languageList[0].name;
    }

    return (
      <Form.Item label={intl.formatMessage(messages.language)} colon={false}>
        {getFieldDecorator('OSLANG', {
          initialValue:
            supos.OSLANG || languageList?.find((item: any) => item.name === supos.OSLANG)?.name || initialValue,
        })(
          <Select>
            {languageList.map((item: any) => {
              return (
                <Option key={item.cnName} value={item.name}>
                  {item.cnName}
                </Option>
              );
            })}
          </Select>,
        )}
      </Form.Item>
    );
  };

  return (
    <Form labelCol={{ span: 5 }} wrapperCol={{ span: 16 }}>
      <div className={styles.box}>
        <div className={styles['form-wrap']}>{language()}</div>
      </div>
      <div className={styles.box}>
        <div className={styles['form-wrap']}>{renderTenant()}</div>
      </div>
      <div className={styles.box}>
        <div className={styles['form-wrap']}>{authorization()}</div>
        {failMes && !form.getFieldValue('sameServerWithOps') && (
          <span className={styles.failed}>
            {intl.formatMessage(messages.sshLinkFail)}：{failMes}
          </span>
        )}
      </div>
    </Form>
  );
});
export default Form.create()(Authorization);
